import styled from 'styled-components'

const InviteBodyWrapper = styled.div`
  padding: 20px 20px 0;
  align-items: center;
  grid-gap: 40px 80px;
  display: grid;
  grid-template-columns: 1fr;
  .app-input-text {
    margin-bottom: 25px;
    width: 100%;
    border-radius: 3px;
    box-shadow: 0 3px 10px 0 rgb(0 0 0 / 16%);
    background-color: #f6f6f6;
    :nth-child(2) {
      margin: 0;
    }
    .react-multi-email {
      padding: 0;
      border: none;
      background-color: transparent;
      span {
        color: #606060;
        padding-left: 8px;
      }
      > div {
        background-color: #ebebeb;
      }
    }
    input {
      width: auto !important;

    }
    input,
    textarea {
      /* border-radius: 3px;
      box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.16);*/
      background-color: transparent;
      border: none;
      padding-right: 20px !important;
      padding-left: 20px !important;
      /* width: 100% !important; */
      ::-webkit-input-placeholder {
        /* Edge */
        color: #606060;
        font-family: "latoregular";
      }

      :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #606060;
        font-family: "latoregular";
      }

      ::placeholder {
        color: #606060;
        font-family: "latoregular";
      }
    }
  }
  .width-class{
    input{
      width: 100% !important;
    }
  }
`;

export { InviteBodyWrapper };